export default {"src":"/_next/static/media/bookmark.9f98e77a.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};